<template>
  <div class="accordion" role="tablist">
    <b-card no-body class="mb-1" v-for="(item, i) in data" :key="i">
      <!--      <b-card-header header-tag="header" class="p-1" role="tab">-->
      <b-button
        block
        v-b-toggle="'details_' + i"
        class="w-100 text-left py-3"
        style="background: #e6f0e9; border: 0; color: #41634a"
        ><span>{{ item.name }}</span>
        <span class="when-opened float-right">
          <b-icon-caret-up-fill></b-icon-caret-up-fill>
        </span>
        <span class="when-closed float-right">
          <b-icon-caret-down-fill></b-icon-caret-down-fill>
        </span>
      </b-button>
      <!--      </b-card-header>-->
      <b-collapse :id="'details_' + i" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-row>
            <b-col cols="12">
              <b-row
                v-if="item.plant[item.plant.length - 1].plant_image.length > 0"
              >
                <b-col
                  cols="2"
                  class="px-1"
                  v-for="x in item.plant[item.plant.length - 1].plant_image"
                >
                  <img
                    :src="domain + x.image_url"
                    style="
                      display: block;
                      width: 100%;
                      max-height: 120px;
                      height: auto;
                    "
                    class="img-fluid float-left"
                    v-img
                  />
                </b-col>
              </b-row>
              <img
                v-else
                class="img-fluid img-thumbnail float-left"
                style="max-height: 100px"
                :src="require(`../assets/images/no-image.png`)"
              />
            </b-col>
            <b-col cols="12">
              <p style="font-weight: bold">รายละเอียดพืช</p>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">ชื่อท้องถิ่น : </span>&nbsp;{{
                    item.plant[item.plant.length - 1].bio_local_name
                  }}
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">แหล่งที่พบ : </span>&nbsp;{{
                    item.plant[item.plant.length - 1].plant_habitat.habitat.name
                  }}
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">ลักษณะเด่น : </span>&nbsp;{{
                    item.plant[item.plant.length - 1].characteristic
                  }}
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">การใช้ประโยชน์ในท้องถิ่น :</span
                  ><template
                    v-for="x in item.plant[item.plant.length - 1]
                      .plant_benefits"
                  >
                    <span v-if="x.benefit_description">
                      &nbsp;{{
                        " " +
                        x.benefit_description +
                        "(" +
                        x.benefit.name +
                        ")"
                      }},
                    </span>
                  </template>
                </span>
              </div>
            </b-col>
            <b-col cols="12" style="display: block">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">ภูมิปัญญา :</span
                  ><template
                    v-for="x in item.plant[item.plant.length - 1]
                      .plant_knowledges"
                  >
                    <span v-if="x.knowledge_description">
                      &nbsp;{{
                        x.knowledge_description +
                        "(" +
                        x.knowledges1.name +
                        ")"
                      }},
                    </span>
                  </template>
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">ฤดูการเก็บเกี่ยว : </span
                  >&nbsp;{{ item.plant[item.plant.length - 1].harvest_season }}
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">สำรวจพบ : </span>&nbsp;{{
                    plantCount
                  }}
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <span
                  ><span style="color: #5a7e64">เก็บธนาคาร : </span>&nbsp;{{
                    bankCount
                  }}
                </span>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="parent">
                <a
                  :href="'/CommunityDetail/' + item.community_id"
                  target="_blank"
                  >คลิกเพื่อดูรายละเอียดชุมชนเพิ่มเติม</a
                >
              </div>
            </b-col>
          </b-row>
          <!--          <b-card-text>{{ item.plant[item.plant.length - 1] }}</b-card-text>-->
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { domain } from "@/utils/Constants";

export default {
  name: "DetailsBio",
  props: {
    data: Array,
    plantCount: Number,
    bankCount: Number,
  },
  data() {
    return {
      selectedImage: "",
      domain: domain,
    };
  },
};
</script>

<style scoped>
.btn {
  width: 100% !important;
  margin: 0;
}
span {
  float: left;
}
p {
  float: left;
  margin-bottom: 0;
}
div.col-12 {
  margin-bottom: 10px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.parent {
  text-align: justify;
  text-justify: inter-word;
}
.card {
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
